import { Injectable } from '@angular/core';
import { HttpParams, HttpClient, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ItemMini } from '../models/item-mini.model';
import { ConfigurationService } from '../../services/configuration.service';


@Injectable({
  providedIn: 'root'
})
export class ItemsApiService {

  constructor(private readonly http: HttpClient,
    private readonly configurations: ConfigurationService) { }


  getAllItems() {
    return this.http.get(`${this.configurations.apiAddress}/api/items/getAllItems`);
  }


  public getAllItemsMini(type: number): Observable<ItemMini[]>;
  public getAllItemsMini(): Observable<ItemMini[]>;
  public getAllItemsMini(type?: number): Observable<ItemMini[]>
  {
    if (type)
      return this.http.get<ItemMini[]>(`${this.configurations.apiAddress}/api/items/getAllItemsMini/${type}`);
    else
      return this.http.get<ItemMini[]>(`${this.configurations.apiAddress}/api/items/getAllItemsMini`);
  }

  // Whole active catalog, not scoped to the logged-in user's business units.
  public getAllItemsMiniUnscoped(): Observable<ItemMini[]>
  {
    return this.http.get<ItemMini[]>(`${this.configurations.apiAddress}/api/items/getAllItemsMiniUnscoped`);
  }

  public getBUItemsMini(businessUnitId: number, year: number=0): Observable<ItemMini[]>
  {
    return this.http.get<ItemMini[]>(`${this.configurations.apiAddress}/api/items/getByBusinessUnit/${businessUnitId}?year=${year}`);
  }


  getAllItemTypes() {
    return this.http.get(`${this.configurations.apiAddress}/api/items/getAllItemTypes`);
  }

  getAllItemsMiniByDate(date) {
    return this.http.get(`${this.configurations.apiAddress}/api/items/getAllItemsMini?date=${date.toDateString()}`);
  }

  // Unscoped by rep/brand, real Skip/Take pagination - for large, scroll-loaded item pickers
  // (e.g. the visit stock-entry table). Response bundles Items + TotalItems in one call.
  searchAllItems(searchText: string, pageSize: number, pageNumber: number) {
    let myParams = new HttpParams()
      .set('searchText', searchText == undefined ? "" : searchText)
      .set('pageSize', pageSize.toString())
      .set('pageNumber', pageNumber.toString());
    return this.http.get(`${this.configurations.apiAddress}/api/items/searchAllItems`, { params: myParams });
  }

}
